import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { AppProvider } from './context/AppContext.tsx'
import { UserEventsProvider } from './SSE'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* HelmetProvider permite que <SEO> actualice los meta tags del
        documento en runtime (cliente). Para el SSG, el prerender script
        usa su propio HelmetProvider + extract. */}
    <HelmetProvider>
      <BrowserRouter>
        <AppProvider>
          <UserEventsProvider>
            <App />
          </UserEventsProvider>
        </AppProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
